import { Filter } from "@api/models/HttpClientModels";

export default class RestaurantFilter extends Filter {
    cityIds? : string;
    isActive?: boolean;
    restaurantTypeIds?: string;
}